import { styled, Grid, Typography } from "@mui/material";

export const StyledBannerGridItem = styled(Grid)(({ theme }) => {
    return {
        display: "flex",
        justifyContent: "start",
        [theme.breakpoints.down("sm")]: {
            justifyContent: "center",
        },
        alignItems: "center",
        padding: "5px 0px 5px 0px !important",
    };
});

export const StyledBannerText = styled(Typography)(({ theme }) => {
    return {
        color: theme.palette.secondary.main,
        fontWeight: "bold",
        [theme.breakpoints.down("md")]: {
            fontSize: "1.5rem !important",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.25rem !important",
            textAlign: "center",
        },
    };
});

export const StyledBannerSubText = styled(Typography)(({ theme }) => {
    return {
        color: theme.palette.secondary.main,
        marginTop: "25px",
        [theme.breakpoints.down("sm")]: {
            textAlign: "center",
        },
    };
});

export const StyledBannerImg = styled("img")(({ theme }) => {
    return {
        margin: "25px 0px 25px 0px",
        objectFit: "contain",
        maxWidth: "150px",
        width: "100%",
        height: "auto",
        [theme.breakpoints.between("sm", "md")]: {
            height: "75%",
        },
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    };
});
